import { usePostTrainingLedgerApi, usePutTrainingLedgerApi } from 'api/training_ledger'
import { Flex } from 'components/shared/flex'
import { DateField, InputField, SelectField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useEffect, useState } from 'react'
import { Accordion, Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { TrainingLedger, TrainingLedgerForm } from 'entities/training_ledger'
import 'rc-time-picker/assets/index.css'
import { CircleButton } from 'components/shared/widget'
import { useFetchUsersApi } from 'api/user'
import { UserSearchForm } from 'entities/user'
import { selectYears } from 'utils/util'
import { TrainingContent } from 'entities/training_content'

const FormView = (form: Form<TrainingLedger>, apiError: ApiError) => {
    return (
        <Flex flexDirection="column">
            <Accordion style={{ width: '100%' }}>
                <Accordion.Item eventKey="training">
                    <Accordion.Header>教育研修記録</Accordion.Header>
                    <Accordion.Body>
                        <Flex flexDirection="column">
                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: 35 }}></th>
                                    <th>実施日</th>
                                    <th>研修内容</th>
                                    <th>備考</th>
                                </tr>
                                <tbody>
                                    {form.object.trainingContentSet
                                        ?.filter((t) => t.recordType === 'training')
                                        .map((c, i) => {
                                            const index =
                                                form.object.trainingContentSet?.findIndex(
                                                    (t) => t === form.object.trainingContentSet?.filter((t) => t.recordType === 'training')[i]
                                                ) ?? -1
                                            return (
                                                <tr key={c.id}>
                                                    <td>
                                                        <div style={{ marginBottom: 22 }}>
                                                            <CircleButton
                                                                onClick={() => {
                                                                    form.update((f) => f.trainingContentSet?.splice(index, 1))
                                                                }}
                                                                variant="danger"
                                                            >
                                                                -
                                                            </CircleButton>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <DateField
                                                            form={form}
                                                            attr={['trainingContentSet', index, 'date']}
                                                            maxDate={new Date(Number(form.object.year) + 1, 3, 0)}
                                                            minDate={new Date(Number(form.object.year), 4, 1)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <InputField form={form} attr={['trainingContentSet', index, 'content']} />
                                                    </td>
                                                    <td>
                                                        <InputField form={form} attr={['trainingContentSet', index, 'memo']} />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    <td>
                                        <CircleButton
                                            onClick={() => {
                                                form.update((f) =>
                                                    f.trainingContentSet?.push({
                                                        recordType: 'training',
                                                        indexInRecordType: Math.max(...f.trainingContentSet.map((c) => c.indexInRecordType!)),
                                                        trainingLedgerMasterId: form.object.id,
                                                    })
                                                )
                                            }}
                                            variant="primary"
                                        >
                                            +
                                        </CircleButton>
                                    </td>
                                </tbody>
                            </table>
                        </Flex>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="accessment">
                    <Accordion.Header>技能評価記録</Accordion.Header>
                    <Accordion.Body>
                        <table style={{ width: '100%' }}>
                            <tr>
                                <th></th>
                                <th>実施日</th>
                                <th>技能評価内容</th>
                                <th>評価</th>
                                <th>備考</th>
                            </tr>
                            <tbody>
                                {form.object.trainingContentSet
                                    ?.filter((c) => c.recordType === 'accessment')
                                    ?.map((_, i) => {
                                        const index =
                                            form.object.trainingContentSet?.findIndex(
                                                (t) => t === form.object.trainingContentSet?.filter((t) => t.recordType === 'accessment')[i]
                                            ) ?? -1
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <div style={{ marginBottom: 22 }}>
                                                        <CircleButton
                                                            onClick={() => {
                                                                form.update((f) => f.trainingContentSet?.splice(index, 1))
                                                            }}
                                                            variant="danger"
                                                        >
                                                            -
                                                        </CircleButton>
                                                    </div>
                                                </td>
                                                <td>
                                                    <DateField
                                                        form={form}
                                                        attr={['trainingContentSet', index, 'date']}
                                                        maxDate={new Date(Number(form.object.year) + 1, 3, 0)}
                                                        minDate={new Date(Number(form.object.year), 4, 1)}
                                                    />
                                                </td>
                                                <td>
                                                    <InputField form={form} attr={['trainingContentSet', index, 'content']} />
                                                </td>
                                                <td>
                                                    <SelectField
                                                        form={form}
                                                        attr={['trainingContentSet', index, 'grade']}
                                                        label=""
                                                        selectItems={['', '合格', '不合格'].map((grade) => ({
                                                            label: grade,
                                                            value: grade,
                                                        }))}
                                                    />
                                                </td>
                                                <td>
                                                    <InputField form={form} attr={['trainingContentSet', index, 'memo']} />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                <td>
                                    <CircleButton
                                        onClick={() => {
                                            form.update((f) =>
                                                f.trainingContentSet?.push({
                                                    recordType: 'accessment',
                                                    indexInRecordType: Math.max(...f.trainingContentSet.map((c) => c.indexInRecordType!)),
                                                    trainingLedgerMasterId: form.object.id,
                                                })
                                            )
                                        }}
                                        variant="primary"
                                    >
                                        +
                                    </CircleButton>
                                </td>
                            </tbody>
                        </table>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Flex>
    )
}

type NewTrainingLedgerFormProps = {
    onComplete?: () => void
    disabled?: boolean
}

export const NewTrainingLedgerForm = (props: NewTrainingLedgerFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostTrainingLedgerApi()
    const userForm = useForm<UserSearchForm>({})
    const userApi = useFetchUsersApi(userForm)
    const initialTrainingContentSet: TrainingContent[] = []
    const form = useForm<TrainingLedgerForm>({
        trainingContentSet: initialTrainingContentSet,
    })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffect(() => {
        userApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(userApi.loading)
    }, [userApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                disabled={props.disabled}
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>教育研修・技能評価記録台帳の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Flex>
                        <SelectField
                            includeBlank
                            form={form}
                            attr="year"
                            label="年度"
                            selectItems={selectYears().map((y) => ({ label: y.label + '度', value: y.value }))}
                        />
                        <SelectField
                            includeBlank
                            form={form}
                            attr="userId"
                            label="スタッフ"
                            selectItems={userApi.response.results?.map((u) => ({ label: u.fullName, value: `${u.id}` }))}
                        />
                    </Flex>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type EditTrainingLedgerFormProps = {
    trainingLedger: TrainingLedger
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditTrainingLedgerForm = (props: EditTrainingLedgerFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutTrainingLedgerApi()
    const form = useForm<TrainingLedgerForm>({})

    useEffect(() => {
        const trainingContentSet = props.trainingLedger?.trainingContentSet ?? []
        if (trainingContentSet?.filter((c) => c.recordType === 'training').length === 0) {
            trainingContentSet.push({ recordType: 'training', indexInRecordType: 0, trainingLedgerMasterId: props.trainingLedger.id })
        }
        if (trainingContentSet?.filter((c) => c.recordType === 'accessment').length === 0) {
            trainingContentSet.push({ recordType: 'accessment', indexInRecordType: 0, trainingLedgerMasterId: props.trainingLedger.id })
        }
        form.set({
            ...props.trainingLedger,
            trainingContentSet: trainingContentSet,
        })
    }, [props.trainingLedger])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal fullscreen show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>教育研修・技能評価記録台帳の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.id && (
                    <>
                        <h3 style={{ marginBottom: 10 }}>{`${form.object.year}年度 / ${globalState.user.fullName}`}</h3>
                        {FormView(form, api.apiError)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
